<ng-container *ngIf="screenSize === 'desktop'; else mobileTemplate">
  <app-customer-orders-desktop></app-customer-orders-desktop>
</ng-container>

<ng-template #mobileTemplate>
  <app-customer-orders-mobile></app-customer-orders-mobile>
</ng-template>
